import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Flex } from 'nallian-shared-ui/lib/components';

const ADDRESS_TYPES = {
  STREET: 1,
  CITY: 3,
  ZIP: 4,
  COUNTRY: 7,
};

const OrganisationAddress = ({ address }) => {
  const street = useMemo(
    () => (address.addressLines || []).find(a => a.typeId === ADDRESS_TYPES.STREET) || {},
    [address]
  );

  const city = useMemo(
    () => (address.addressLines || []).find(a => a.typeId === ADDRESS_TYPES.CITY) || {},
    [address]
  );

  const country = useMemo(
    () => (address.addressLines || []).find(a => a.typeId === ADDRESS_TYPES.COUNTRY) || {},
    [address]
  );

  const zip = useMemo(
    () => (address.addressLines || []).find(a => a.typeId === ADDRESS_TYPES.ZIP) || {},
    [address]
  );

  return (
    <Flex>
      {street.value ? `${street.value}` : ''}
      {street.value && city.value && zip.value && `, `}
      {city.value && zip.value ? `${zip.value} ${city.value}` : ''}
      {city.value && zip.value && country.value && `, `}
      {country.value}
    </Flex>
  );
};

OrganisationAddress.propTypes = { address: PropTypes.object };
OrganisationAddress.defaultProps = { address: {} };

const OrganisationAddresses = ({ addresses }) => (
  <>
    {addresses.map((address, k) => (
      <OrganisationAddress key={`address_${k}`} address={address} />
    ))}
  </>
);

OrganisationAddresses.propTypes = { addresses: PropTypes.array };
OrganisationAddresses.defaultProps = { addresses: [] };

export default OrganisationAddresses;
